<div class="end">
    <ion-button class="close" color="light" (click)="close.next()">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
    </ion-button>
</div>

<div class="content">
    <ng-content></ng-content>
</div>
